/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentPrizeBreakdownItem
 */
export interface TournamentPrizeBreakdownItem {
    /**
     * 
     * @type {number}
     * @memberof TournamentPrizeBreakdownItem
     */
    place?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentPrizeBreakdownItem
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentPrizeBreakdownItem
     */
    amount?: number;
}

/**
 * Check if a given object implements the TournamentPrizeBreakdownItem interface.
 */
export function instanceOfTournamentPrizeBreakdownItem(value: object): value is TournamentPrizeBreakdownItem {
    return true;
}

export function TournamentPrizeBreakdownItemFromJSON(json: any): TournamentPrizeBreakdownItem {
    return TournamentPrizeBreakdownItemFromJSONTyped(json, false);
}

export function TournamentPrizeBreakdownItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizeBreakdownItem {
    if (json == null) {
        return json;
    }
    return {
        
        'place': json['place'] == null ? undefined : json['place'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function TournamentPrizeBreakdownItemToJSON(json: any): TournamentPrizeBreakdownItem {
    return TournamentPrizeBreakdownItemToJSONTyped(json, false);
}

export function TournamentPrizeBreakdownItemToJSONTyped(value?: TournamentPrizeBreakdownItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'place': value['place'],
        'percentage': value['percentage'],
        'amount': value['amount'],
    };
}

